const Alerts = () => {
  return (
    <>
      <div className="market-info__content-title-container">
        <div className="market-info__content-title">Teavitused</div>
      </div>
      <div style={{ fontStyle: "italic", paddingTop: "10px" }}>
        Vaja ehitada juurde backend'i loogika ja äkki suunata kasutaja hoopis{" "}
        <b>seadete</b> lehele, kust ta saab ise vastavalt linnukese lisada, kas
        soovib teavitusi meilile või ei.
      </div>
    </>
  );
};

export default Alerts;
